/**
 * Nav glyphs and the mark. Vite rewrites these `new URL`s into served assets
 * for both the app and Storybook, so nothing has to live in a public folder.
 */
export const navigationIcons = {
  home: new URL('./home.svg', import.meta.url).href,
  monitor: new URL('./monitor.svg', import.meta.url).href,
  knowledge: new URL('./knowledge.svg', import.meta.url).href,
  explore: new URL('./explore.svg', import.meta.url).href,
  integrations: new URL('./integrations.svg', import.meta.url).href,
  inventory: new URL('./ziggiz-inventory.svg', import.meta.url).href,
  mark: new URL('./ziggiz.svg', import.meta.url).href
} as const;
